import { Navigate, Link } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { Lock } from 'lucide-react';

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center"><div className="animate-spin w-8 h-8 border-4 border-[#56dfb4] border-t-transparent rounded-full" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export function AdminRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center"><div className="animate-spin w-8 h-8 border-4 border-[#b456df] border-t-transparent rounded-full" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== 'admin') return <Navigate to="/dashboard" replace />;
  return children;
}

export function PaidRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center"><div className="animate-spin w-8 h-8 border-4 border-[#56dfb4] border-t-transparent rounded-full" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.subscription_tier === 'free' && user.role !== 'admin') {
    return (
      <div className="min-h-[60vh] flex items-center justify-center px-4" data-testid="upgrade-prompt">
        <div className="text-center max-w-md">
          <div className="w-16 h-16 rounded-2xl bg-[#b456df]/10 flex items-center justify-center mx-auto mb-4">
            <Lock className="w-8 h-8 text-[#b456df]" />
          </div>
          <h2 className="text-2xl font-bold mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>Members-Only Feature</h2>
          <p className="text-slate-500 mb-6">This feature requires a paid membership. Upgrade your plan to unlock messaging, player search, the Discussion Board, and more.</p>
          <div className="flex items-center justify-center gap-3">
            <Link to="/subscription">
              <Button className="rounded-full bg-[#b456df] text-white hover:bg-[#9a3ec4] px-8" data-testid="upgrade-btn">Upgrade Now</Button>
            </Link>
            <Link to="/pricing">
              <Button variant="outline" className="rounded-full px-6" data-testid="view-pricing-btn">View Plans</Button>
            </Link>
          </div>
        </div>
      </div>
    );
  }
  return children;
}
